
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanConeUp as ObiBuoyCanConeUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-cone-up.js';
 
 
 

 
 export const ObiBuoyCanConeUp = createComponent({
   react: React,
   tagName: 'obi-buoy-can-cone-up',
   elementClass: ObiBuoyCanConeUpElement,
   events: {
     
   }
  });
 
 